import React, { useRef, useState } from "react";
import Modal from "react-modal";
import { StatusFilter } from "../../render-helpers";
import { BuddyTable } from "../../table-helpers/BuddyTable-2";
import { notify } from "../../utilities/customFunctions";

const levelOptions = [
    {
        "label": "High",
        "value": "High",
    },
    {
        "label": "Medium",
        "value": "Medium",
    },
    {
        "label": "Low",
        "value": "Low",
    }
]

const initialData = [
    { id: 1, mainDomain: "Newscorp", subdomains: 23, level: "Medium" },
    { id: 2, mainDomain: "Penske Media", subdomains: 115, level: "Medium" },
    { id: 3, mainDomain: "Publift", subdomains: 177, level: "Medium" },
    { id: 4, mainDomain: "Interplay", subdomains: 7, level: "Medium" },
    { id: 5, mainDomain: "Seven Network", subdomains: 4, level: "Medium" },
];



const PublisherPrioritization = () => {
    const [data, setData] = useState(initialData);

    const [isModalOpen, setIsModalOpen] = useState(false)

    const closeModal = () => { setIsModalOpen(false) }
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
          const file = e.target.files[0];
          console.log("Selected CSV file:", file.name);
          // TODO: parse or process the file
        }
      };

    // Handle changing the prioritization level in the dropdown
    const handleLevelChange = (id, newLevel) => {        
        setData((prevData) =>
            prevData.map((item) =>
                item.id === id ? { ...item, level: newLevel } : item
            )
        );
    };

    // Helper function to get stats for a given level
    const getStatsForLevel = (level) => {
        const filtered = data.filter((item) => item.level === level);
        const totalDomains = filtered.length;
        const totalSubdomains = filtered.reduce(
            (acc, item) => acc + item.subdomains,
            0
        );
        return { totalDomains, totalSubdomains };
    };

    // Compute stats for each prioritization level
    const highStats = getStatsForLevel("High");
    const mediumStats = getStatsForLevel("Medium");
    const lowStats = getStatsForLevel("Low");

    // Handlers for the buttons (placeholder implementations)
    const handleUploadCSV = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
          }
    };

    const handleSave = () => {
        notify("Publisher Prioritisation Level Saved.", "s")
        closeModal()
    };

    const renderInput = (label, input1 = "", label2="", input2 = "", className = "") => {
        return (
            <div className={"d-flex flex-row flex-wrap p-0 col justify-content-start " + className}>
                <label className="mb-1 bb-form-input-label-first mr-2 text-right pt-2 bb-form-dsp-label">{label}</label>

                <span className="form-control fake-input  mb-2  mr-2 small text-right">{input1}</span>

                <label className="mb-1 bb-form-input-label mr-2 text-right pt-2 bb-form-dsp-label">{label2}</label>

                <span className="form-control fake-input mb-2  mr-2 small text-right">{input2}</span>

            </div>

        )

    }

    const renderModal = () => {
        return (
            <Modal
                isOpen={isModalOpen ? true : false}
                onRequestClose={(e) => closeModal()}
                overlayClassName="bb-modal-overlay"
                className="bb-modal-container "
                ariaHideApp={false}
                bodyOpenClassName="overflow-hidden"
            >
                <div>
                <div className="d-flex flex-row justify-content-between mb-3 modal-header bb-bg_primary">
                                        <h4 className="text-white">Publisher Prioritisation</h4>
                                        <div className="bb-modal-close fas fa-times fa-2x cursor-pointer text-white" onClick={(e) => closeModal()}>
                                        </div>
                                    </div>
                    
                <div className="col-auto d-flex align-items-center bb-font_14px flex-column h-470 overflow-auto">
                    <p>
                        Each month, this platform will supply a mix of all publishers, with
                        priority given based on their prioritisation level.
                    </p>
                    <BuddyTable
                        defaultValue={1}
                        pagesize={1}
                        tableSorting={false}
                        showPagination={false}
                        showRowtable={false}
                        emptyMessage="No Data Found."
                        paginateClassName="col-12"
                        skeletonloading={false}
                        total={1}
                        loading={false}
                        currentPage={1}
                        data={data}
                        className="cursor-pointer w-100 mb-3 buddy_light publisher p-0"
                        dataFor=""
                        columns={[                                                            
                            {
                                Header: "Main Domain",
                                accessor: "mainDomain",
                                className: "text-center mx-48",
                                minWidth: 100,
                            },
                            {
                                Header: "Subdomain",
                                accessor: "subdomains" ,
                                className: "text-center mx-48",
                                minWidth: 70,                                                               
        
                            },
                            {
                                Header: "Prioritisation Level",
                                accessor: "level",
                                minWidth: 160,
                                maxWidth: 300,
                                className: "d-flex justify-content-center mx-48",
                                Cell: ({ row }) => (
                                    <div>
                                        <StatusFilter noLabel={true} 
                                            status={row.original.level} 
                                            isDefault={false} 
                                            onChange={(e) => handleLevelChange(row.original.id, e.target.value)}
                                            placeholder="Choose..." optionData={levelOptions} isCleanable={false}
                                            menuClassName="bb-font_14px" marginBottom={false}
                                            container={document.getElementById('bb-container-main')}
                                        />
                                    </div>
                                )
                            },
                        ]}
                    /> 
                    
                    <div className="publisher-bottom row mb-3 w-100 bb-ad-all-border">
                        <div className="col-9 pt-2">
                        {renderInput("Main Domains Prioritised High", highStats.totalDomains, "Subdomains", highStats.totalSubdomains)}
                        {renderInput("Main Domains Prioritised Medium", mediumStats.totalDomains, "Subdomains", mediumStats.totalSubdomains)}
                        {renderInput("Main Domains Prioritised Low", lowStats.totalDomains, "Subdomains", lowStats.totalSubdomains)}
                        </div>
                        <div className="col d-flex flex-column justify-content-center align-items-center">
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: "none" }}
                                    accept=".csv"
                                    onChange={handleFileChange}
                                />
                                <button type="button" className="bb-button mb-3" onClick={handleUploadCSV}>Upload CSV</button>
                                <button type="button" className="bb-button bb-back-button"onClick={handleSave}>
                                    Save
                                </button>
                            </div>
                    </div>
                    

                    
                </div>
                </div>
            </Modal>
        );
    }

    return (
        <>
            {isModalOpen ? renderModal() : null}
            <button type="button" onClick={() => { setIsModalOpen(true) }} className={"p-2 bb-button roas-button border-0 mt-0 mw-unset"} >
                Apply Prioritisation
            </button>
        </>
    )
};

export default PublisherPrioritization;
